import RelationshipAddEmailInfoComponent from './RelationshipAddEmailInfoContainer';

export default RelationshipAddEmailInfoComponent;